import { AxiosResponse } from 'axios';
import { showToast } from '../../actions/toast.action';
import { getCampaignsApi } from '../../api/Dhwani/dashboard.api';
import {
  GET_CAMPAIGNS,
  GET_CAMPAIGNS_WITH_DELAY,
} from '../../constants/ActionTypes';
import { HTTP_STATUS_CODES } from '../../constants/HttpConstants';
import { IDhwaniDashboardQueryParamsPayload } from '../../types/dhwani/dashboard.types';
import { errorHandler } from '../utils.saga';
import { call, put, takeLatest, delay } from 'redux-saga/effects';
import { EToastVariant } from 'do-front-end-utils';

function* getCampaigns(data: IDhwaniDashboardQueryParamsPayload, delayMs = 0) {
  try {
    if (delayMs > 0) {
      // Apply delay to allow Elasticsearch to sync with Postgres
      yield delay(delayMs);
    }

    const getCampaignsResp: AxiosResponse = yield call(() =>
      getCampaignsApi(data.payload)
    );
    if (
      getCampaignsResp &&
      getCampaignsResp.status === HTTP_STATUS_CODES.OK &&
      getCampaignsResp.data
    ) {
      yield put({
        type: `${GET_CAMPAIGNS}_SUCCESS`,
        payload: getCampaignsResp.data.data,
      });
    } else {
      yield put(
        showToast({
          id: 'drd-dhwani-campaigns-error-toast',
          message: getCampaignsResp.data.message,
          variant: EToastVariant.ERROR,
        })
      );
    }
  } catch (err) {
    const message: string | null = yield call(errorHandler, err);
    if (message)
      yield put(
        showToast({
          id: 'drd-dhwani-campaigns-error-toast',
          message,
          variant: EToastVariant.ERROR,
        })
      );
  }
}

/**
 * Load Candidates
 * @returns {void}
 */
export default function* loadDhwaniDashboard() {
  yield takeLatest(
    GET_CAMPAIGNS,
    function* (action: IDhwaniDashboardQueryParamsPayload) {
      yield call(getCampaigns, action, 0);
    }
  );
  yield takeLatest(
    GET_CAMPAIGNS_WITH_DELAY,
    function* (action: IDhwaniDashboardQueryParamsPayload) {
      yield call(getCampaigns, action, 2000);
    }
  );
}
